import React from 'react';

function CreditCard01({ fill, ...restProps }) {
  return (
    <>
      <svg
        fill={fill ?? ''}
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
        {...restProps}
      >
        <path
          d='M3.749 4.045c-.782.075-1.347.326-1.859.825-.399.39-.654.861-.796 1.47-.07.303-.074.596-.074 5.68v5.36l.091.355c.17.671.526 1.227 1.031 1.615a2.86 2.86 0 0 0 1.123.539l.355.091h8.36c8.008 0 8.373-.003 8.68-.074.799-.186 1.381-.579 1.826-1.235.199-.293.321-.587.42-1.011.07-.303.074-.596.074-5.66s-.004-5.357-.074-5.66c-.218-.936-.739-1.603-1.577-2.019-.31-.153-.623-.23-1.149-.279-.537-.051-15.903-.048-16.431.003m16.625 2.029c.201.068.487.357.547.552.029.094.055.585.068 1.264L21.01 9H3v-.87c.001-1.094.042-1.489.179-1.696.154-.233.368-.354.687-.392.151-.018 3.892-.03 8.314-.026 6.491.005 8.07.016 8.194.058m.616 8.036c-.011 2.37-.027 3.147-.065 3.264-.065.197-.347.48-.549.551-.233.082-16.519.082-16.752 0-.202-.071-.484-.354-.549-.551-.038-.117-.054-.894-.065-3.264L2.996 11h18.008l-.014 3.11'
          fill-rule='evenodd'
          fill={fill ?? ''}
        />
      </svg>
    </>
  );
}

export default CreditCard01;
